import { NumberField } from "./NumberField";
import { NumberStyle } from "./NumberStyle";
import { PositionPicker } from "./PositionPicker";

const inputCls = "mt-1 w-full border-2 border-slate-200 bg-white px-3 py-2.5 text-sm font-semibold outline-none transition-colors focus:border-slate-900";

export const DetailsPanel = ({ player, sport, onChange, hideClub, accent }) => {
  const set = (patch) => onChange({ ...player, ...patch });
  return (
    <div className="space-y-4">
      <label className="block text-sm font-bold">Player name
        <input value={player.name} maxLength={40} onChange={(e) => set({ name: e.target.value })} placeholder="e.g. Seán Ó Briain"
          className={inputCls} data-testid="player-name-input" />
        <span className="text-xs font-normal text-slate-500">Long names shrink automatically to fit the shield.</span>
      </label>
      <div className="sm:w-1/2 sm:pr-2">
        <NumberField id="rating" label="Overall rating" value={player.rating} onCommit={(rating) => set({ rating })} testId="player-rating-input" />
      </div>
      <PositionPicker player={player} sport={sport} set={set} inputCls={inputCls} />
      <div className="sm:w-1/2 sm:pr-2">
        <NumberField id="shirt" label="Shirt number (optional)" value={player.shirtNumber ?? ""} max={99} emptyHint="Leave empty to hide"
          onCommit={(shirtNumber) => set({ shirtNumber })} testId="player-shirt-number-input" />
      </div>
      {player.shirtNumber && <NumberStyle player={player} accent={accent} onChange={set} />}
      <p className="-mt-2 text-xs text-slate-500">The overall rating is entered by you – it isn't calculated from the statistics.</p>
      {!hideClub && <label className="block text-sm font-bold">Club name
        <input value={player.clubName} maxLength={50} onChange={(e) => set({ clubName: e.target.value })} placeholder="e.g. St. Brigid's GAA"
          className={inputCls} data-testid="club-name-input" />
      </label>}
    </div>
  );
};
